export enum VoucherValidationResult {
	Ok = 0,
	CodeAlreadyExists = 1,
	VoucherOrMechanicExists = 2,
}
